export const createHostMicroFrontendManager = () => {
    const eventHandlers = new Map();
    let remoteLoaded = false;
    const api = {
        dispatch(eventName, payload) {
            console.log('[Host] Dispatching event:', eventName, payload);
            if (!remoteLoaded) {
                console.warn('[Host] Remote component not yet loaded. Cannot dispatch event.');
                return;
            }
            const handlers = eventHandlers.get(eventName);
            if (handlers) {
                handlers.forEach(handler => handler(payload));
            }
        },
        subscribe(eventName, handler) {
            if (!remoteLoaded) {
                console.warn('[Host] Remote component not yet loaded. Subscription will be pending.');
            }
            if (!eventHandlers.has(eventName)) {
                eventHandlers.set(eventName, new Set());
            }
            const handlers = eventHandlers.get(eventName);
            handlers?.add(handler);
            console.log('[Host] Subscribed to event:', eventName);
            return () => this.unsubscribe(eventName, handler);
        },
        unsubscribe(eventName, handler) {
            const handlers = eventHandlers.get(eventName);
            if (handlers) {
                handlers.delete(handler);
                if (handlers.size === 0) {
                    eventHandlers.delete(eventName);
                }
            }
        },
        setRemoteLoaded(loaded) {
            remoteLoaded = loaded;
            console.log('[Host] Remote component loaded status:', loaded);
        },
        isRemoteLoaded() {
            return remoteLoaded;
        }
    };
    return api;
};
